import { define, Model, AttributesMixin } from "@type-r/models";
import { restfulIO } from 'api/endpoint';

export interface Region extends AttributesMixin<typeof Region> { }

@define
export class Region extends Model {
  static endpoint = restfulIO('/api/v1/incash/cash-balance/regions');

  static attributes = {    
    id: String,
    label: String
  }
}